/* eslint-disable import/no-commonjs */
/* eslint-disable global-require */
/*
 * @providesModule I18nLocales
 */

import 'moment/locale/de-at';
import 'moment/locale/de-ch';
import 'moment/locale/de';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/en-gb';
import 'moment/locale/en-ie';
import 'moment/locale/en-in';
import 'moment/locale/en-nz';
import 'moment/locale/es-do';
import 'moment/locale/es-us';
import 'moment/locale/es';
import 'moment/locale/fr-ca';
import 'moment/locale/fr-ch';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/pt-br';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';
import 'moment/locale/zh-tw';

import {
  NativeModules,
  Platform,
} from 'react-native';
import moment from 'moment';

const I18nLocales = {
  _currentLocale: null,
  _currentMoment: null,
  _deviceLocale: null,

  get currentLocale() {
    if (!this._currentLocale) {
      this._currentLocale = this._normalizeLocale(Platform.OS == 'android' ?
        NativeModules.SkillzModule.Locale :
        NativeModules.SKZReactLocaleManager.locale);
    }
    return this._currentLocale;
  },

  set currentLocale(locale) {
    this._currentLocale = locale;
    moment.locale(this._getMomentLocaleFromI18nLocale(locale));
    this._currentMoment = this._normalizeMomentModuleLocale(locale);
  },

  get currentMoment() {
    return this._currentMoment;
  },

  get deviceLocale() {
    if (!this._deviceLocale) {
      this._deviceLocale = this._normalizeLocale(Platform.OS == 'android' ?
        NativeModules.SkillzModule.Locale :
        NativeModules.SKZReactLocaleManager.locale);
    }
    return this._deviceLocale;
  },

  set deviceLocale(value) {
    this._deviceLocale = value;
  },

  _normalizeLocale(locale) {
    /*
     IOS returns date formates with regions as below 
     'en_IR' moment is designed to work with the format 'en-ir' 
     so we need to update to the correct format
    */
    const formattedLocale = locale?.toLowerCase().replace('_', '-');
    const match = formattedLocale?.match(/^([a-z]{2})$|^([a-z]{2})[-]([a-z]{2,})$/i);
    if (match) {
      const matchedLocale = match[0];
      return matchedLocale; // matches come back as an array ['en-ir', 'en', 'ir'] or ['en'] if no region specified
    } 
    return 'en';
  },

  _normalizeMomentModuleLocale(locale) {
    const lowerCaseLocale = locale.toLowerCase();
    if (lowerCaseLocale == 'en-in') {
      return lowerCaseLocale;
    }
    return this._normalizeLocale(lowerCaseLocale);
  },

  _getMomentLocaleFromI18nLocale(locale) {
    const moment_ = this._normalizeMomentModuleLocale(locale);
    if (moment_ == 'zh') {
      return 'zh-cn';
    } else {
      return moment_;
    }
  },

  _getMomentModule(locale) {
    return I18nLocales.moments[this._normalizeMomentModuleLocale(locale)];
  },

  updateCurrentMomentForLocale(locale) {
    const momentLocale = I18nLocales._getMomentModule(locale);
    if (momentLocale) {
      I18nLocales.currentLocale = locale;
    } else {
      I18nLocales.currentLocale = 'en';
    }
  },

  messages: {
    de: require('./de.json'),
    en: require('./en.json'),
    'en-in': require('./en.json'),
    es: require('./es.json'),
    fr: require('./fr.json'),
    it: require('./it.json'),
    ja: require('./ja.json'),
    pt: require('./pt-br.json'),
    'pt-br': require('./pt-br.json'),
    ru: require('./ru.json'),
    zh: require('./zh-Hans.json'),
    'zh-hans': require('./zh-Hans.json'),
  },

  moments: {
    de: require('moment/locale/de'),
    'en-in': require('moment/locale/en-in'),
    es: require('moment/locale/es'),
    fr: require('moment/locale/fr'),
    it: require('moment/locale/it'),
    ja: require('moment/locale/ja'),
    pt: require('moment/locale/pt-br'),
    'pt-br': require('moment/locale/pt-br'),
    ru: require('moment/locale/ru'),
    zh: require('moment/locale/zh-cn'),
    'zh-hans': require('moment/locale/zh-cn'),
  },

  ordinals: {
    de: {
      one: '.',
      two: '.',
      few: '.',
      many: '.',
      zero: '.',
      other: '.',
    },
    es: {
      one: 'º',
      two: 'º',
      few: 'º',
      many: 'º',
      zero: 'º',
      other: 'º',
    },
    en: {
      one: 'st',
      two: 'nd',
      few: 'rd',
      many: 'th',
      zero: 'th',
      other: 'th',
    },
    fr: {
      one: 'er',
      two: 'e',
      few: 'e',
      many: 'e',
      zero: 'e',
      other: 'e',
    },
    it: {
      one: 'º',
      two: 'º',
      few: 'º',
      many: 'º',
      zero: 'º',
      other: 'º',
    },
    ja: {
      one: '目',
      two: '目',
      few: '目',
      many: '目',
      zero: '目',
      other: '目',
    },
    pt: {
      one: 'º',
      two: 'º',
      few: 'º',
      many: 'º',
      zero: 'º',
      other: 'º',
    },
    'pt-br': {
      one: 'º',
      two: 'º',
      few: 'º',
      many: 'º',
      zero: 'º',
      other: 'º',
    },
    ru: {
      one: 'º',
      two: 'º',
      few: 'º',
      many: 'º',
      zero: 'º',
      other: 'º',
    },
    zh: {
      one: '第',
      two: '第',
      few: '第',
      many: '第',
      zero: '第',
      other: '第',
    },
    'zh-hans': {
      one: '第',
      two: '第',
      few: '第',
      many: '第',
      zero: '第',
      other: '第',
    },
    'en-in': {
      one: 'st',
      two: 'nd',
      few: 'rd',
      many: 'th',
      zero: 'th',
      other: 'th',
    },
  },
};

export default I18nLocales;
